import { render, staticRenderFns } from "./Subalmacenes.vue?vue&type=template&id=5d347df4&"
import script from "./Subalmacenes.vue?vue&type=script&lang=js&"
export * from "./Subalmacenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports